'use strict';

var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

export default Marionette.View.extend({

  tagName: 'li',
  className: 'calendar-empty',

  render: function () {
    this.$el.text(polyglot.t('calendar.empty'));
    return this;
  },

  show: function () {
    this.$el.show();
  },

});
